export default __webpack_public_path__ + "static/hero_right-d224ad50641a41241f849d85ed8e1cde.png";